'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _events = require('events');

var _util = require('../util.js');

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Addible = function (_EventEmitter) {
  (0, _inherits3.default)(Addible, _EventEmitter);

  function Addible(data) {
    (0, _classCallCheck3.default)(this, Addible);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Addible.__proto__ || (0, _getPrototypeOf2.default)(Addible)).call(this));

    _this.data = data;
    _this.resetCount();
    _this.setActivityPrice();
    return _this;
  }

  (0, _createClass3.default)(Addible, [{
    key: 'resetCount',
    value: function resetCount() {
      !this.data.count && (this.data.count = 1);
    }
  }, {
    key: 'setActivityPrice',
    value: function setActivityPrice() {
      this.activityPrice = this.data.spv.price;
      this.activityRawPrice = this.data.spv.rawPrice;
    }
  }, {
    key: 'packTap',
    value: function packTap() {
      if (this.editMode) {
        return;
      }
      if (isApp) {
        window.location.href = 'beastapp://product/' + this.data.productId;
      } else {
        window.location.href = '/product/' + this.data.productId;
      }
    }
  }, {
    key: 'addibleButtonTap',
    value: function addibleButtonTap() {
      var _this2 = this;

      if (this.pending) {
        return;
      }
      this.pending = true;
      if (this.data.owned) {
        this.cancel(this.data.id).then(function () {
          _this2.pending = false;
          _util2.default.track('addible-cancel');
          _this2.data.owned = false;
          _this2.data.id = null;
          _this2.$emit('complete');
        }).catch(function (_ref) {
          var message = _ref.message;

          _this2.pending = false;
          _this2.$alert(message);
        });
      } else {
        if (!this.data.spv.left) {
          this.$alert('抱歉，该商品已售罄');
          this.pending = false;
          return;
        }

        if (this.data.hasVariants) {
          this.selectVariant().then(function (result) {
            return _this2.addToCart(result.count);
          }).catch(function (error) {
            _this2.pending = false;
          });
        } else {

          var quota = this.data.spv.quota;
          if (quota) {
            if (quota.left > 1) {
              this.selectCount().then(function (count) {
                _this2.addToCart(count);
              }).catch(function (error) {
                _this2.pending = false;
              });
            } else {
              this.addToCart();
            }
          } else {
            this.selectCount().then(function (count) {
              _this2.addToCart(count);
            }).catch(function (error) {
              _this2.pending = false;
            });
          }
        }
      }
    }
  }, {
    key: 'cancelAddible',
    value: function cancelAddible() {
      var _this3 = this;

      return this.cancel().then(function () {
        _this3.data.owned = false;
        _this3.data.id = null;
        _this3.emit('complete');
      });
    }
  }, {
    key: 'setVariant',
    value: function setVariant(_ref2) {
      var _this4 = this;

      var result = _ref2.result,
          variant = _ref2.variant;

      variant.spvs.forEach(function (spv) {
        // spv's price is not relatived with activity
        // use activity price in cart
        spv.price = _this4.activityPrice;
        spv.rawPrice = _this4.activityRawPrice;
        if (spv.id === result.spvId) {
          _this4.data.spv = spv;
        }
      });
    }
  }, {
    key: 'selectCount',
    value: function selectCount() {
      return this.$selectVariant({
        pack: _util2.default.transformPack(this.data),
        variant: {
          dimensions: [],
          spvs: [this.data.spv]
        },
        selectAmount: true
      }).then(function (result) {
        return result.count;
      });
    }
  }, {
    key: 'addToCart',
    value: function addToCart() {
      var _this5 = this;

      var count = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      return this.add(this.data.spv.id, count).then(function (_ref3) {
        var code = _ref3.code,
            data = _ref3.data;

        _this5.data.owned = true;
        _this5.data.id = data[0];
        _this5.data.count = count;
        _this5.emit('complete');
      });
    }
  }, {
    key: 'selectVariant',
    value: function selectVariant() {
      var _this6 = this;

      return _util2.default.selectVariant({
        pack: this.data,
        selectAmount: true,
        quota: this.data.spv.quota,
        extraQuota: true
      }).then(function (_ref4) {
        var result = _ref4.result,
            variant = _ref4.variant;

        variant.spvs.forEach(function (spv) {
          // spv's price is not relatived with activity
          // use activity price in cart
          spv.price = _this6.activityPrice;
          spv.rawPrice = _this6.activityRawPrice;
          if (spv.id === result.spvId) {
            _this6.data.spv = spv;
          }
        });
        return result;
      });
    }
  }, {
    key: 'editMode',
    value: function editMode(val) {
      this.data.editMode = val;
    }
  }]);
  return Addible;
}(_events.EventEmitter);

exports.default = Addible;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@beastshop/cart/lib/model/base/addible.js
// module id = 668
// module chunks = 0